import React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const Resource = ({ header, title, subtitle, ctaTitle, ctaHref, image }) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  return (
    <Grid container spacing={4}>
      <Grid
        item
        container
        justifyContent="center"
        alignItems="center"
        xs={12}
        md={6}
        data-aos={isMd ? "fade-right" : "fade-up"}
      >
        <Box height={"100%"} width={"100%"} maxWidth={400}>
          {image}
        </Box>
      </Grid>
      <Grid item xs={12} md={6} data-aos={isMd ? "fade-left" : "fade-up"}>
        <Box marginTop={4}>
          <Typography
            sx={{
              textTransform: "uppercase",
              fontWeight: "medium",
            }}
            gutterBottom
            color={"secondary"}
          >
            {header}
          </Typography>
          <Box
            component={Typography}
            fontWeight={700}
            variant={"h4"}
            gutterBottom
          >
            {title}
          </Box>
          <Typography variant={"h6"} component={"p"} color={"textSecondary"}>
            {subtitle}
          </Typography>
        </Box>
        <Box marginBottom={4} sx={{ textAlign: { xs: "center", lg: "left" } }}>
          <Button
            variant="contained"
            color="primary"
            component="a"
            target="_blank"
            size="large"
            href={ctaHref}
            sx={{ marginTop: 3 }}
          >
            {ctaTitle}
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Resource;
